<template>
  <div class="bgg">
    <div class="p-3 bg-gray-200 inline-block m-3">
      <router-link to="/GSRibbon">GSRibbon</router-link>
    </div>
    <div class="p-3 bg-gray-200 inline-block m-3">
      <router-link to="/GSTube">GSTube</router-link>
    </div>

    <div class="p-3 bg-gray-200 inline-block m-3 ">
      <router-link to="/audio">AudioVisualiser</router-link>
    </div>
    <div class="p-3 bg-gray-200 inline-block m-3">
      <router-link to="/AudioVisualiserSphere">AudioVisualiserSphere</router-link>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.bgg{
  background-color: white;
}
</style>
